import React, { useState, useEffect } from 'react';
import { Container, Col, Form, Alert, Spinner } from "react-bootstrap";
import { BfColInput } from '../../../Styling/FormComponents/FormInput'
import { BfYellowRowForm, BfTightYellowRowForm, BfButtonBlue, BfCheckboxContainer, BfCheckboxInput, BfTightRowForm, BfFormLabelSm, BfRowSpacer, YellowRoundedContainer, ArticleAreaNySak } from '../../../Styling/styledForm/styledBlueForm'
import { ArticleArea } from '../../../Styling/Layout/ContentArea';
import { useDispatch } from 'react-redux'
import styled from 'styled-components';
import FakturaTableAI from '../debitorFormWithAI/FakturaTableAI';
import useDebitorFormWithAI from './useDebitorFormWithAI';

const RequiredField = styled.p`
  font-size: 18px; 
  font-weight: 400; 
  color: #000000; 
  padding-left: 24px;
`;

const UploadFileText = styled.p`
  font-size: 20px; 
  font-weight: 400; 
  color: #000000; 
  padding-left: 24px;
  margin-top: 10px; 
`;

const CheckboxText = styled.span`
  font-size: 18px;
  font-weight: 400; 
  padding-left: 20px;
  text-align: center;
  color: #000000;
  font-family: "RM Neue", "sans-serif";
`;

const FakturaResultForm = ({state, formState, handleChange,
    hasErrorsFaktura, errorMessages, extraErrors, localeMessages,
    onUploadFileChange, fileUploadRef, currencyOptions, submitForm,
    uploadFaktura, finalizeFaktura, editFaktura, deleteFaktura, clearForm, selectedUploadFile}) => {

    const fakturaInfo = state.pdfInfo;
    const [checked, setChecked] = useState(false);

    // Vil vise varseltrekant med info om fakturagebyr om teksten inneholder ordet gebyr
    const fieldValue = formState.requiredFakturatekst || '';
    const showWarning = fieldValue.toLowerCase().includes('gebyr');
    const checkBelopWarning = !!formState.requiredBelop;

    const handleCheckboxChange = () => {
        setChecked(!checked);
      };

    useEffect(() => {
    if (state.clearFakturaInfo) {
        setChecked(false);
        clearForm();
        state.clearFakturaInfo = false;
    }
    }, [state]);

    const fakturaTekst = fakturaInfo.kosinvoiceLineList[0].specification ?? "";

    const getFormField = (colspan, fieldname, inputType = 'text', selectOptions = '', disabled = false, maxLength = 524288) => {
        return (
            <BfColInput
                colspan={colspan}
                name={fieldname}
                inputType={inputType}
                onChange={handleChange}
                errorMessages={errorMessages}
                extraErrors={extraErrors}
                messages={localeMessages}
                required
                formState={formState}
                //state={state}
                selectOptions={selectOptions}
                disabled={disabled}
                maxLength={maxLength}
                warning={showWarning}
                belopWarning={checkBelopWarning}
                fakturaTextWarning={fakturaTekst?.length > 29}
                fakturaText={fakturaTekst}
            />
        )
    }

    const handleButtonClick = () => {
        if (fileUploadRef.current) {
            fileUploadRef.current.click();
        }
    };

    const pStyle = {
        width: '100%'
    }

    const HighAmountAlert = () => {
    
            if (formState.requiredBelop) {
                let fBelop = parseFloat(formState.requiredBelop.replaceAll(' ', '').replaceAll(',','.'))
                if (fBelop > 1000000)
                    return (
                        <Alert variant="info">Du har oppgitt et beløp større enn en million.  Kontroller at du ikke har tastet feil beløp.</Alert>
                    )
            } 
            
            return null
    
    }

    const hasRequiredValues = () =>
        [!hasErrorsFaktura, formState.requiredFakturatekst, formState.requiredFakturanummer, formState.requiredFakturadato, formState.requiredForfallsdato, formState.requiredBelop].every(Boolean);

    return (
        <Container fluid style={pStyle}>

            <Form autoComplete="chrome-off" onSubmit={e => e.preventDefault()}>
                <BfRowSpacer></BfRowSpacer>

                <ArticleAreaNySak>
                    <h1>{localeMessages.resultFakturaHeader}</h1>
                    <p>{localeMessages.resultFakturaP}</p>
                </ArticleAreaNySak>

                <YellowRoundedContainer fluid style={{ padding: '15px' }}>
                    <RequiredField>{localeMessages.requiredField}</RequiredField>

                    <HighAmountAlert />

                    {hasErrorsFaktura && (
                        <Alert fluid variant='danger'>
                            {localeMessages.youHaveErrors}
                        </Alert>
                    )}

                    <BfYellowRowForm>
                        {getFormField(4, 'requiredFakturanummer', null, null, false, 60)}
                        {getFormField(4, 'requiredFakturatekst', 'fakturaText', null, false, 29)}
                        {getFormField(4, 'requiredKid', null, null, false, 25)}
                    </BfYellowRowForm>

                    <BfYellowRowForm>
                        {getFormField(3, 'requiredFakturadato', 'cleaveDate')}
                        {getFormField(3, 'requiredForfallsdato', 'cleaveDate')}
                        {getFormField(3, 'valuta', 'select', currencyOptions)}
                        {getFormField(3, 'requiredBelop', 'cleaveAmountPDF', null, false)}
                    </BfYellowRowForm>

                    <BfTightYellowRowForm>
                        <Col xs={12} md={12}>
                            <BfFormLabelSm>{localeMessages.velgFilLabel}</BfFormLabelSm><br />
                            <div style={{ display: 'flex', alignItems: 'center' }} >
                                <BfButtonBlue variant="primary" onClick={handleButtonClick}>
                                    <i className="fa fa-cloud-upload" style={{ marginRight: '8px' }} />
                                    {localeMessages.uploadFileButton}
                                </BfButtonBlue>
                                <input
                                    type="file"
                                    ref={fileUploadRef}
                                    accept="application/pdf"
                                    style={{ display: 'none' }}
                                    onChange={onUploadFileChange}
                                />
                                {selectedUploadFile && selectedUploadFile.length > 0 ? 
                                    <UploadFileText>{selectedUploadFile[0].name}</UploadFileText>
                                    : <UploadFileText>{'Ingen fil valgt'}</UploadFileText>}
                            </div>
                        </Col>
                    </BfTightYellowRowForm>

                    <BfTightYellowRowForm>
                        <BfCheckboxContainer style={{display: 'flex', paddingBottom: '12px' }}>
                            <BfCheckboxInput
                                checked={checked}
                                onChange={handleCheckboxChange}
                                disabled={!hasRequiredValues()}
                            />
                            <CheckboxText>{localeMessages.checkbox_faktura_text}</CheckboxText>
                        </BfCheckboxContainer>
                        <Col xs={12} md={12}>
                            <BfButtonBlue 
                                variant="primary" 
                                type="button" 
                                onClick={() => { 
                                    submitForm(); 
                                    window.scrollTo({top: document.documentElement.scrollHeight - 200, behavior: 'smooth'});
                                }} 
                                disabled={hasErrorsFaktura || !checked}
                            >
                                {!formState.lineNo ? localeMessages.LeggTilFaktura : localeMessages.Oppdater}
                            </BfButtonBlue>
                            &nbsp;&nbsp;&nbsp;

                            <BfButtonBlue variant="primary" type="button"
                                onClick={() => {
                                    clearForm();
                                    checked && handleCheckboxChange();
                                  }}>
                                {localeMessages.ClearForm}
                            </BfButtonBlue>

                        </Col>
                    </BfTightYellowRowForm>
                    <BfTightYellowRowForm />
                </YellowRoundedContainer>

            </Form>

            <BfRowSpacer></BfRowSpacer>

            <ArticleArea>
                <h1>{localeMessages.FL_Head}</h1>
                {(state.invoices.length === 0) && <p>{localeMessages.FL_Caption2}</p>}
                {(state.invoices.length !== 0) && <p>{localeMessages.FL_Caption3}</p>}
            </ArticleArea>

            {(state.invoices.length !== 0) &&
                <Container fluid>
                    <BfTightRowForm>
                        <FakturaTableAI
                            fakturaListe={state.invoices}
                            editFaktura={editFaktura}
                            deleteFaktura={deleteFaktura}
                            messages={localeMessages}
                        />
                    </BfTightRowForm>

                    <BfTightRowForm>
                        <Col xs={12} md={12}>
                            <BfButtonBlue variant="primary" type="button"
                                onClick={() => finalizeFaktura()}
                                disabled={state.invoices.length === 0}>
                                {localeMessages.SendInn}
                            </BfButtonBlue>
                        </Col>
                    </BfTightRowForm>

                    <BfTightRowForm />

                </Container>
            }
        </Container>
    )
}

export default FakturaResultForm

